<template>
  <div>
    <h3 class="text-2xl md:text-4xl font-bold font-heading mb-2">Contact Info</h3>
    <p>{{ contact.first_name }} {{ contact.last_name }}</p>
    <p>{{ contact.email }}</p>
    <p>{{ contact.phone }}</p>
  </div>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'

import { useCheckoutStore } from '@/stores/checkout'

const checkoutStore = useCheckoutStore()
const { contact } = storeToRefs(checkoutStore)
</script>
